import React from "react";
import { Pitch } from "@services/Pitches.service";
import moment from "moment";
import { formatTimeRemaining } from "../utils/formatTimeRemaining";

type Props = {
  pitch: Pitch;
};

export const PitchDesktopExpandedRow = ({ pitch }: Props) => {
  const rows = [
    {
      label: "TIME REMAINING",
      content:
        pitch.time_remaining && pitch.time_remaining > 0
          ? formatTimeRemaining(pitch.time_remaining)
          : "Finished",
    },
    {
      label: "TYPE",
      content: pitch.specialisation_type || "-",
    },
    {
      label: "PITCH DATE",
      content: pitch.pitch_date
        ? moment(pitch.pitch_date).format("MMM DD, yyyy")
        : "-",
    },
    {
      label: "PITCH NAME",
      content: pitch.title ?? "-",
    },
  ];

  return (
    <div className="flex gap-8 px-4 py-2">
      {rows.map(({ label, content }) => (
        <div key={label}>
          <div className="text-[11px] uppercase font-semibold">{label}</div>
          <div className="text-sm mt-1">{content}</div>
        </div>
      ))}
    </div>
  );
};
